import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default
class SizeInformer extends Component {
    static propTypes = {
        onResized: PropTypes.func.isRequired,
        lastUpdate: PropTypes.instanceOf(Date).isRequired
    }

    static defaultProps = {
        lastUpdate: new Date(0)
    }

    onResized = () => {
        const { onResized } = this.props;

        if (!this.element) {
            return;
        }

        const {
            clientWidth: width,
            clientHeight: height,
            scrollWidth,
            scrollHeight
        } = this.element;

        // console.log('sizeinformer element', this.element)
        onResized({
            width,
            height,
            scrollWidth,
            scrollHeight
        });
    }

    componentDidMount() {
        this.onResized();

        window.addEventListener('resize', this.onResized, false);
        window.addEventListener('orientationchange', this.onResized, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResized);
        window.removeEventListener('orientationchange', this.onResized);
    }

    componentDidUpdate({ lastUpdate }) {
        if (this.props.lastUpdate.getTime() !== lastUpdate.getTime()) {
            this.onResized();
        }
    }

    render() {
        const {
            onResized,
            lastUpdate,
            ...props
        } = this.props;

        return (
            <div
                ref={ref => this.element = ref}
                {...props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/base/SizeInformer.js